import { classNames } from "~/utils/etc";

/**
 * "Powered by Hubble" branding badge
 */
export function HubbleBadge() {
  return (
    <div class="flex items-center justify-center gap-2">
      <span class="text-label-semi-bold text-text-normal-primary">
        Powered by
      </span>
      <HubbleLogoTelescope />
    </div>
  );
}

export function HubbleLogoTelescope(props: { class?: string }) {
  return (
    <svg
      class={classNames(props.class, "h-[13px]")}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1890.21 351.66"
      // fill={}
      style={{
        fill: "var(--text-normal-primary)",
      }}
    >
      <path
        d="M716.49,488.65q21.45,25.17,21.44,68.43V684.22h-76V566.84q0-19.1-9.93-29.83c-6.65-7.14-15.53-10.72-26.72-10.72q-17.18,0-27.3,11.13T587.8,568V684.25H511V395.65H587.8V502.14a70.63,70.63,0,0,1,27.3-28.09q17.92-10.53,42.13-10.52Q695,463.46,716.49,488.65Zm210.57,92.61q0,19.89-10.13,30.83T889.63,623q-16.78,0-26.72-10.72T853,582.84V465.46H776.53V592.22q0,43.69,21.65,68.84t59.46,25.14q24.17,0,42.13-10.52a70.78,70.78,0,0,0,27.29-28.08v36.65h76.45V465.46H927.06ZM1267.93,515Q1280,540.3,1280,574.62t-12.09,59.87q-12.11,25.56-33.16,39A85.8,85.8,0,0,1,1187.58,687q-23,0-39.77-9.94a61.67,61.67,0,0,1-25-27.5v34.7H1046V395.62h76.82V500.15a61.49,61.49,0,0,1,25-27.5q16.79-10,39.77-9.93,26.13,0,47.19,13.46T1267.93,515Zm-65.53,59.67q0-21.06-11.12-33c-7.4-7.92-17.11-11.89-29-11.89q-17.18,0-28.46,12.09t-11.31,32.75q0,21.06,11.31,33.15t28.46,12.09c11.94,0,21.65-4,29-11.88S1202.4,588.92,1202.4,574.62ZM1532.75,515q12.11,25.35,12.09,59.67t-12.09,59.87q-12.11,25.56-33.15,39A85.86,85.86,0,0,1,1452.4,687q-23,0-39.77-9.94a61.72,61.72,0,0,1-25-27.5v34.7h-76.82V395.62h76.82V500.15a61.55,61.55,0,0,1,25-27.5q16.78-10,39.77-9.93,26.13,0,47.2,13.46T1532.75,515Zm-65.52,59.67q0-21.06-11.13-33t-29-11.89c-11.45,0-20.91,4-28.46,12.09s-11.3,19-11.3,32.75q0,21.06,11.3,33.15c7.55,8.07,17,12.09,28.46,12.09q17.92,0,29-11.88T1467.23,574.62Zm108.4,109.6h76.83V395.62h-76.83Zm327.61-95.56H1758.53q2,37.07,32.37,37.06,11.32,0,18.73-5.45a27.29,27.29,0,0,0,10.14-14.42h81.11a92.65,92.65,0,0,1-19.11,41.54,102.6,102.6,0,0,1-37.44,29.05Q1821.7,687,1794.81,687q-32.77,0-57.92-13.46a95.09,95.09,0,0,1-39.19-39q-14-25.53-14-59.87t14-59.67a95.25,95.25,0,0,1,39.39-38.8q25.35-13.47,57.72-13.46,32.78,0,57.71,13.25a94.77,94.77,0,0,1,38.81,37.85q13.85,24.56,13.83,56.93A88.69,88.69,0,0,1,1903.24,588.66Zm-76-32q.39-16.77-9-25.34c-6.24-5.71-14-8.6-23.4-8.6q-15.19,0-24.76,8.6c-6.38,5.71-10.08,14.18-11.13,25.34Zm-1545-159.53a42.74,42.74,0,0,0,4.29-20.89h0a43,43,0,0,0-74.53-27.21h0L38.05,539.75a86.4,86.4,0,1,0,143.6,90.72Zm32.66,158a64.94,64.94,0,1,0,64.94,64.94A64.94,64.94,0,0,0,314.82,555.16Z"
        transform="translate(-14.95 -335.3)"
      />
    </svg>
  );
}
